import settings from "./settings";

export default {
    results: (state) => state.results,
    search_type_display: (state) => settings[state.search_type].verbose_name_plural,
    search_type_choices: (state, getters, rootState, rootGetters) => {
        const filtered = {};
        for (const [key, value] of Object.entries(settings)) {
            if (!value.require || rootGetters["auth/test_permissions"](value.require)) {
                filtered[key] = value;
            }
        }
        return filtered;
    },
    component: (state) => settings[state.search_type].component
}